import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { CommonProjectDataService } from "../../_services/common-project-data.service";


@Component({
  selector: 'app-term-invoice',
  templateUrl: './term-invoice.component.html',
  styleUrls: ['./term-invoice.component.css']
})
export class TermInvoiceComponent implements OnInit {
  public loading = false;
  public invoiceOptions: any = {};
  public invoiceList: Array<any> = [];
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 100;
  public search: string = "";
  public sortColumnName = "invoice_id";
  public sortDirection = "desc";
  public filterText: string;
  public userData: any = {};
  constructor(private CommonService: CommonService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService
  ) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userDetails'));
    this.getTermInvoiceList();
    
  }

  getTermInvoiceList = function () {
    this.loading = true;
    this.invoiceOptions = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };

    if (this.filterText) {
      this.invoiceOptions.search = this.filterText;
    }

    if (this.sortDirection) {
      this.invoiceOptions.orderBy = this.sortColumnName;
      this.invoiceOptions.direction = this.sortDirection;
    }

    this.CommonService.apiService(
      "POST",
      "accounts/receivable/invoices",
      this.invoiceOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.invoiceList = response.data.records;
            this.total = response.data.total;
            this.current_page = response.data.current_page;
            this.limit = response.data.limit;

            this.CommonProjectDataService.receivableCount.next(this.total);
            this.userData.receivable_count = this.total;
            localStorage.setItem("userDetails", JSON.stringify(this.userData));
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  goToPage(n: number): void {
    this.page = n;
    this.getTermInvoiceList();
  }

  onNext(): void {
    this.page++;
    this.getTermInvoiceList();
  }

  onPrev(): void {
    this.page--;
    this.getTermInvoiceList();
  }
  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getTermInvoiceList();
  }
  filterType(): void {
    this.page = 1;
    this.total = 0;
    this.getTermInvoiceList();
  }
  clearFilter(): void {
    this.filterText = "";
    this.page = 1;
    this.total = 0;
    this.getTermInvoiceList();
  }

  viewClient(userId) {
    if (this.userData.type != 'Printer' && this.userData.type != 'Designer') {
      this.router.navigate(['/clients/listing', { id: userId }]);
    }
  }
  viewInvoiceCart(id) {
    this.router.navigate(['/invoices', { id: id }]);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/term-invoice/term-invoice.component.ts